import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

class Main extends Component {
  render() {
    return <Navigate to='/app' />;
  }
}
export default Main;
